import React from 'react'
import styled from 'styled-components'
import { withStyles, makeStyles } from '@material-ui/core/styles';

// components
import Grid from '@material-ui/core/Grid'
import Tooltip from '@material-ui/core/Tooltip';

// styled components
const Wrapper = styled(Grid)`
  min-height: 34.4px;
  color: ${({color}) => color};
  background-color: ${({background}) => background};
  padding: 6px 10px;
`;

const Circle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;
  border: 1px solid white;
  cursor: pointer;
`;

const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: 14,
    fontWeight: 'normal'
  },
}))(Tooltip);

// function
const ColoredLabel = ({title, tooltip = '', background = 'gray', color = 'white'}) => {

  return (
    <Wrapper
      container
      justify="space-between"
      alignItems="center"
      color={color}
      background={background}
      wrap="nowrap"
    >
      <span>{ title }</span>
      <CustomTooltip title={tooltip} style={{marginLeft: 'auto'}} placement="right">
        <Circle>?</Circle>
      </CustomTooltip>
    </Wrapper>
  )
}

export default ColoredLabel;
